import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Permission } from 'src/app/models/Permission';
import { PermissionService } from 'src/app/services/permission.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-rol',
  templateUrl: './rol.component.html',
  styleUrls: ['./rol.component.scss']
})
export class RolComponent implements OnInit {
  @ViewChild('detailModal') detailModal: ModalDirective;
  @ViewChild('deleteModal') deleteModal: ModalDirective;
  @ViewChild('addModal') addModal: ModalDirective;

  titulos: String[] = ['Individuo', ''];
  roles: String[] = [];
  usersTable: String[] = [];
  usersList: string[] = [];
  filterList: string[] = [];
  selectRole: String;
  selectUser: String;
  selectUserAdd: String;
  windows: String[] = [];
  indexRemoveSelect: number;
  keyword = '';
  headingWindows: any;




  constructor(private spinner: NgxSpinnerService, private toastr: ToastrService, private permissionService: PermissionService) { }

  ngOnInit() {
    this.getUsers();
    this.spinner.show();
    this.permissionService.getRole().subscribe(
      data => {
        if (getToken(data)) {
          if (data.roles != null && data.roles.length > 0) {
            for (let i = 0; i < data.roles.length; i++) {
              if (data.roles[i].name != 'INDIVIDUO') {
                this.roles.push(data.roles[i].name);
              }
            }
          } else {
            this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS DE ROLES", "ERROR");
          }
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
      }
    )
    this.spinner.hide();
    jQuery.getScript(CONSTANTES.menu);

  }

  async getUsers() {
    this.permissionService.getUsers().subscribe(
      data => {
        this.usersList = [];
        for (let i = 0; i < data.users.length; i++) {
          this.usersList.push(data.users[i]);
        }
        this.toastr.success("LOS USUARIOS SE HAN CARGADO", "INFORMACION");
      },
      error => {
        this.toastr.error("ERROR AL OBTENER LOS USUARIOS", "ERROR");
      }

    )
  }

  // Obtenemos el detalle para poder visualizar las pantallas del rol
  getWindowsDetail() {
    this.spinner.show();
    this.detailModal.show();
    this.spinner.hide();
  }

  selectRol() {
    if (this.selectRole != null) {
      let permission = new Permission();
      permission.rol = this.selectRole.toString();
      this.spinner.show();
      this.permissionService.getUsersRole(permission).subscribe(
        data => {
          if (getToken(data)) {

            this.usersTable = [];
            this.windows = [];
            for (let i = 0; i < data.windows.length; i++) {
              this.windows.push(data.windows[i].name);
            }

            for (let i = 0; i < data.usersData.length; i++) {
              this.usersTable.push(data.usersData[i]);
            }



            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
          this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
        }
      )
    }
  }

  /**Muestra el modal de confirmación*/
  remove(index: number) {
    this.indexRemoveSelect = index;
    this.deleteModal.show();
  }

  /**Método que se encargar de eliminar un registro*/
  delete() {
    this.spinner.show();
    let permission = new Permission();
    permission.usersData = [];
    permission.usersData.push(this.usersTable[this.indexRemoveSelect].toString());
    permission.rol = this.selectRole.toString();
    this.spinner.show();
    this.permissionService.postDelete(permission).subscribe(
      data => {
        if (getToken(data)) {
          this.usersTable = [];

          for (let i = 0; i < data.usersData.length; i++) {
            this.usersTable.push(data.usersData[i]);
          }
          this.spinner.hide();
          this.toastr.success("DATO BORRADO CORRECTAMENTE", "INFO");
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL BORRAR LOS DATOS", "ERROR");
      }
    )

    this.indexRemoveSelect = null;
    this.deleteModal.hide();
  }

  /**Método para añadir registros*/
  add() {
    // this.action = "Insertar";
    //  this.createData(0);
    if (this.usersList.length == 0) {
      this.toastr.warning("LOS USUARIOS AUN NO SE HAN CARGADO ESPERE UN POCO", "AVISO");
    }
    else {
      this.addModal.show();
    }
  }


  /**Método que se encarga de cerrar y liberar la memoria del modal*/
  closeModal() {
    this.addModal.hide();
    this.addModal.ngOnDestroy();
  }

  insertData() {
    this.spinner.show();
    let permission = new Permission();
    permission.usersData = [];
    permission.usersData.push(this.selectUser.toString());
    permission.rol = this.selectRole.toString();
    if (this.usersTable.includes(this.selectUser)) {
      this.toastr.error("EL USUARIO YA TIENE PERMISOS");
      this.spinner.hide();
    }
    else {
      this.permissionService.postSave(permission).subscribe(
        data => {
          if (getToken(data)) {
            this.usersTable = [];

            for (let i = 0; i < data.usersData.length; i++) {
              this.usersTable.push(data.usersData[i]);
            }
            this.spinner.hide();
            this.filterList = [];
            this.addModal.hide();
            this.addModal.ngOnDestroy();
            this.selectUser = '';
            this.toastr.success("DATO INSERTADO CORRECTAMENTE", "INFO");
          }
        },
        error => {
          this.selectUser = '';
          this.spinner.hide();
          this.toastr.error("HA OCURRIDO UN ERROR AL INSERTAR LOS DATOS", "ERROR");
        }
      )
    }

  }

  /**Permite obtener el individuo*/
  selectEvent(item) {
    // do something with selected item
    this.selectUser = item;
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if (val != '') {
      this.filterList = this.usersList.filter(value =>
        value.toLocaleUpperCase().includes(val.toLocaleUpperCase())
      )
      if (this.filterList.length > 500) {
        this.filterList = this.filterList.slice(0, 500)
      }
    }
  }

  onFocused(e) {

  }

}
